import React, { useCallback, useEffect, useState } from "react";
import SettingList from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier";
import { MockSetDig, getMediaSettings } from "./setting-digital.type";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";

const PAGE_KEY = "digital-asset";

const MediaMgtSet = () => {
  const { getToggle, getInput, setToggle, setInput, hydrateMany} = useSettingsDraft();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        const res = await getMediaSettings();
        if (!alive) return;

        const s = res.data.data.settings;

        hydrateMany({
          pageKey: PAGE_KEY,
          toggles: [
            { groupId: 1, itemId: 1, value: !!s.name.required },
            { groupId: 1, itemId: 2, value: !!s.alt.required },
            { groupId: 2, itemId: 1, value: !!s.delete.confirm.enabled },
            { groupId: 2, itemId: 2, value: !!s.delete.enabled },
            { groupId: 2, itemId: 3, value: !!s.delete.used.enabled },
            { groupId: 2, itemId: 4, value: !!s.asset.use.enabled },
            { groupId: 3, itemId: 1, value: !!s.upload.personal.enabled },
            { groupId: 3, itemId: 3, value: !!s.asset.use.enabled },
          ],
          inputs: [{ groupId: 3, itemId: 2, value: String(s.upload.maxFileSizeMb ?? "") }],
        });

      } catch (e) {
        console.error("GET media settings failed:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [hydrateMany]);

  const isChecked = useCallback(
    (groupId: number, itemId: number) => getToggle(PAGE_KEY, groupId, itemId),
    [getToggle]
  );

  const onToggle = useCallback(
    (payload: { groupId: number; groupTitle: string; itemId: number; itemTitle: string; checked: boolean }) => {
      setToggle({
        pageKey: PAGE_KEY,
        groupId: payload.groupId,
        groupTitle: payload.groupTitle,
        itemId: payload.itemId,
        itemTitle: payload.itemTitle,
        value: payload.checked,
      });
    },
    [setToggle]
  );

  const getInputValue = useCallback(
    (groupId: number, itemId: number) => getInput(PAGE_KEY, groupId, itemId),
    [getInput]
  );

  const onInputChange = useCallback(
    (groupId: number, itemId: number, value: string, groupTitle?: string, itemTitle?: string) => {
      setInput({
        pageKey: PAGE_KEY,
        groupId,
        groupTitle,
        itemId,
        itemTitle,
        value,
      });
    },
    [setInput]
  );

  return (
    <main>
      {MockSetDig.map((group) => (
        <SettingList
          key={group.id}
          groupId={group.id}
          mainTitle={group.title}
          paragraph={group.description}
          setList={group.items}
          isChecked={isChecked}
          onToggle={onToggle}
          getInputValue={getInputValue}
          onInputChange={(groupId, itemId, value) => {
            const item = group.items.find((x) => x.id === itemId);
            onInputChange(groupId, itemId, value, group.title, item?.title);
          }}
        />
      ))}
    </main>
  );
};

export default MediaMgtSet;